import { React, ProductTile, Text, Button } from "xolabot-sdk";
import { BooleanAddon } from "./BooleanAddon";
import { ChoicesAddon } from "./ChoicesAddon";
import { QuantityAddon } from "./QuantityAddon";
import config from "../config.json";

export const AbstractAddon = ({ addon }) => {
    const components = {
        choices: ChoicesAddon,
        boolean: BooleanAddon,
        quantity: QuantityAddon,
    };

    const SpecificComponent = components[addon.object];

    return (
        <Text
            align="center"
            style={{
                border: "1px solid #ccc",
                position: "relative",
                paddingBottom: 15,
                minHeight: 320,
            }}
        >
            <div style={{ marginBottom: 30 }}>
                <h3 style={{ fontWeight: "normal" }}>{addon.name}</h3>
                <img
                    style={{ width: 130 }}
                    src={`${config.xola.url}${addon.photo ? addon.photo.src : "/images/placeholder.png"}`}
                />
                <p>{addon.desc}</p>
            </div>
            <div
                style={{
                    position: "absolute",
                    bottom: 15,
                    width: "100%",
                    textAlign: "center",
                }}
            >
                <SpecificComponent addon={addon} />
            </div>
        </Text>
    );
};
